<div class="touch-spin-container">
    <span class="roundbuttonsub" (click)="tSpinSub()"><i class="theme-minus"></i></span>
    <span #touchspinvalue class="valuebox"> {{ value }} </span>
    <span class="roundbuttonadd" [ngStyle]="{ 'background-color': color }" [ngClass]="{ disbled: addDisbled }" (click)="tSpinAdd()"
        ><i class="theme-plus"></i
    ></span>
</div>
